import { ComposantAttenduSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const ComposantAttenduModel: SelectorModel = {
  name: 'composantAttendus',
  getSelector: ComposantAttenduSelectors.selectAllComposantAttendusDictionary,
  isReady: ComposantAttenduSelectors.selectIsReadyComposantAttendu
};
